import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=13b06ac2"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=13b06ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports